import React from 'react';
import { Box, Card, CardContent, Container, Typography } from '@mui/material';

const OrderingUnderConstruction: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Card elevation={3} sx={{ borderRadius: 3 }}>
        <CardContent sx={{ p: { xs: 3, md: 5 } }}>
          <Typography
            variant="h4"
            color="primary"
            sx={{ mb: 3, fontWeight: 600, textAlign: 'center' }}
          >
            Emblem / Chapter Supplies
          </Typography>
          <Box sx={{ maxWidth: 820, mx: 'auto' }}>
            <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
              Due to system constraints beyond our control, the P.E.O.
              International Online Ordering Site is currently unavailable. A new
              Chapter Supplies site will be launching soon. During this
              transition time, please use the Official Emblem and the Local
              Chapter Supply Order Forms found on the P.E.O. Hub under
              Resources/Library for ordering. If you have questions, please call
              515-255-3153 or email contactus@peodsm.org. Thank you for your
              patience as we improve the P.E.O. ordering process!
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default OrderingUnderConstruction;
